import { render, staticRenderFns } from "./adminMenu.vue?vue&type=template&id=7d224708&scoped=true&"
import script from "./adminMenu.vue?vue&type=script&lang=js&"
export * from "./adminMenu.vue?vue&type=script&lang=js&"
import style0 from "./adminMenu.vue?vue&type=style&index=0&id=7d224708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d224708",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTab,VTabs})
